import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import { DESKTOP, MOBILE } from '../../../../constants/Devices';
import { RIPLEY_BANNERS } from '../../../../constants/Banners';
import BannerSticky from '../../../common/banner-sticky/BannerSticky';
import BannerStickyImage from '../../../common/banner-sticky/BannerStickyImage';
import { getBannerBankAction } from '../../../../redux/actions/BannerActions';
import { openNewTabOrNewWindow } from '../../../../helpers/UrlHelper';
import ImageIsLoading from '../../../common/image-loading/ImageIsLoading';

const RipleyBankBannerSticky = (props) => {
  /**
   * Parameters
   */
  const { setAppearanceFor } = props?.banner;
  const DEVICE =
    setAppearanceFor === DESKTOP ? DESKTOP.toLowerCase() : MOBILE.toLowerCase();

  /**
   * Settings || Constants
   *
   */
  const WIDTH_BANNER = RIPLEY_BANNERS.STICKY.BANK.DESKTOP.IMG.WIDTH;
  const HEIGHT_BANNER = RIPLEY_BANNERS.STICKY.BANK.DESKTOP.IMG.HEIGHT;
  const ANIMATIONS = {
    WAVE_DOTS: 'WAVE_DOTS',
    CIRCULAR_PROGRESS: 'CIRCULAR_PROGRESS',
  };

  // RESOLVE: temporal code for loading animation, until UX Area decide the best animation way, but,
  //  is a good idea for create a shared animation service!
  const LOADING_ANIMATIONS = [];
  const fixWidth = `${WIDTH_BANNER.split('px')[0] - 30}px`;
  const baseDiv = (cmpt) => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'white',
          width: fixWidth,
          height: HEIGHT_BANNER,
        }}
      >
        {cmpt}
      </div>
    );
  };
  LOADING_ANIMATIONS[ANIMATIONS.CIRCULAR_PROGRESS] = baseDiv(
    <CircularProgress size={20} color={'white'} />,
  );
  LOADING_ANIMATIONS[ANIMATIONS.WAVE_DOTS] = baseDiv(
    <ImageIsLoading
      loadingSettings={{
        imgAlt: 'Cargando Imágen',
        imgWidth: '56px',
        imgHeight: '20px',
      }}
    />,
  );

  /**
   * React Hooks
   */
  const { banner, bannerStatus } = useSelector((state) => state?.bannerReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    if (bannerStatus !== 'succeeded') {
      dispatch(getBannerBankAction());
    }
  }, []);

  /**
   * Props
   */
  const imageProps = {
    imgSrc: banner?.images?.[DEVICE],
    animationLoading: LOADING_ANIMATIONS[ANIMATIONS.WAVE_DOTS],
    imgWidth: WIDTH_BANNER,
    imgHeight: HEIGHT_BANNER,
    clickAction: () => {
      return openNewTabOrNewWindow(banner?.links?.[DEVICE]);
    },
    bannerImageId: 'RipleyBankBannerSticky-ImageId-01',
  };
  const bannerProps = {
    textOnTab: RIPLEY_BANNERS.STICKY.BANK.DESKTOP.TEXT_ON_TAB,
    width: `${WIDTH_BANNER.split('px')[0] - 2}px`,
    height: HEIGHT_BANNER,
    isExpandBannerOn: RIPLEY_BANNERS.STICKY.BANK.DESKTOP.EXPANDED_ON,
    isShownHiderButtonOn: RIPLEY_BANNERS.STICKY.BANK.DESKTOP.HIDER_ON,
    isShownBannerOn: RIPLEY_BANNERS.STICKY.BANK.DESKTOP.SHOW_BANNER_ON,
    bannerReference: 'RipleyBankBannerSticky-01',
    component: <BannerStickyImage image={imageProps} />,
    bannerIsShownId: 'RipleyBankBannerSticky-isShownId-01',
    bannerExpandedId: 'RipleyBankBannerSticky-ExpandedId-01',
  };

  return (
    <>
      <BannerSticky banner={bannerProps} />
    </>
  );
};

RipleyBankBannerSticky.propTypes = {
  banner: PropTypes.shape({
    setAppearanceFor: PropTypes.string,
  }),
};

export default RipleyBankBannerSticky;
